import { collection, query, where } from "firebase/firestore";
import { useCallback, useEffect, useState } from "react";
import dbService from "../../../../firebase/dbService";
import { db } from "../../../../config/firebaseConfig";

const useFetchExamQuestins = ({ participantDetails }) => {
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [error, setError] = useState();

  const fetchQuestionsData = useCallback(async (subject, candidateClass) => {
    const q = query(
      collection(db, "questions"),
      where("subject", "==", subject),
      where("className", "==", candidateClass)
    );

    const questions = await dbService.getDocsWithQuery(q);
    return questions;
  }, []);

  useEffect(() => {
    const subject = participantDetails?.examSubject;
    const candidateClass = participantDetails?.className;
    const fetchQuestions = async () => {
      try {
        setLoading(true);
        const questions = await fetchQuestionsData(subject, candidateClass);
        setQuestions(questions);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    if (subject && candidateClass) {
      fetchQuestions();
    }
  }, [participantDetails, fetchQuestionsData]);

  return { loading, questions, error };
};

export default useFetchExamQuestins;
